import { useParams, useSearchParams } from 'react-router-dom';
import { useProductData } from '../../hooks/useProductData';
import { ErrorPage } from '../ErrorPage/ErrorPage';
import { FabricPage } from './FabricPage/FabricPage';
import { ProductDetailPage } from './ProductDetailPage/ProductDetailPage';

export function ProductPage() {
	const { productId } = useParams<{ productId: string }>();
	const [searchParams] = useSearchParams();
	const { product, isLoading, error } = useProductData(productId!);

	// TODO: remove — temporary: ?skeleton=true forces the loading state
	const forceLoading = searchParams.get('skeleton') === 'true';

	if (!isLoading && !forceLoading && (error || !product)) {
		return <ErrorPage />;
	}

	if (!isLoading && !forceLoading && product?.productType?.name === 'Fabric') {
		return <FabricPage product={product} />;
	}

	return <ProductDetailPage product={product} loading={isLoading || forceLoading} />;
}
